const SHARE_MARKET_PARAM = "market";
export const SHARE_CARD_PARAM = "card";
export const SHARE_CARD_CONSENSUS = "consensus";
export const SHARE_CARD_NONE = "none";

interface IShareCardMarket {
  id: string;
  platform: string;
}

export const buildShareCardPath = (marketId: string, mode: string): string =>
  `/og/${marketId}/${mode}.png`;

export const resolveShareCardImage = (
  pageUrl: string,
  markets: readonly IShareCardMarket[],
  apiBaseUrl: string
): string | null => {
  const params = new URL(pageUrl).searchParams;
  const card = params.get(SHARE_CARD_PARAM);
  const market = markets.find(
    ({ id }) => id === params.get(SHARE_MARKET_PARAM)
  );

  if (!market || card === SHARE_CARD_NONE) {
    return null;
  }

  const mode =
    card === SHARE_CARD_CONSENSUS ? SHARE_CARD_CONSENSUS : market.platform;

  return `${apiBaseUrl}${buildShareCardPath(market.id, mode)}`;
};
